import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const TaskFiltersContainer = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`

export const Filters = styled(Box)`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const DateRangeContainer = styled(Box)`
  display: flex;
  gap: 10px;
  padding: 8px;
`

export const ClearFiltersContainer = styled(Box)`
  display: flex;
  gap: 17px;
  padding-left: 10px;
`
